/* * 商品列表 * 作者： */
<template>
  <div class="">
    <Navigation v-if="hasNav" ref="nav" :isShow="true" />
  </div>
</template>

<script>
// @ is an alias to /src
import VerticalSlide from '@/components/VerticalSlide.vue';
import ScrollView from '@/components/ScrollView.vue';
import Navigation from '@/buscomponents/Navigation.vue';

// import request from '@/util/request';

export default {
  name: 'home',
  components: {
    VerticalSlide,
    ScrollView,
    Navigation
  },
  data() {
    return {
      data: [],
      pulldown: false,
      list: ['images/1.jpg', 'images/2.jpg', 'images/3.jpg', 'images/4.jpg', 'images/5.jpg', 'images/6.jpg', 'images/7.jpg', 'images/8.jpg'],
      hasNav: false
    };
  },
  methods: {
    onscroll(e) {
      console.log(e);
    }
  },
  mounted() {
    this.hasNav = true;

    let startClintY = 0;
    $(this.$refs.mainWrapper).on('touchstart', e => {
      const { touches } = e;
      startClintY = touches[0].clientY;
      console.log('touchstart', e);
    });

    $(this.$refs.mainWrapper).on('touchmove', e => {
      console.log('touchmove', e);
      const { touches } = e;
      const moveClintY = touches[0].clientY;
      const dis = moveClintY - startClintY;
      console.log(touches, moveClintY, startClintY);
      // console.log('touchend', Math.abs(this.$refs.viewNav.scroll.y));
      if (Math.abs(this.$refs.viewNav.scroll.y) === 0) {
        if (dis < 0) {
          console.log('disable');
          this.$refs.viewNav.scroll.enable();
        } else {
          console.log('enable');
          this.$refs.viewNav.scroll.disable();
          this.$refs.verticalSlide.slide.enable();
        }
      } else {
        this.$refs.verticalSlide.slide.disable();
      }
    });
  },
  destroyed() {
    this.$refs = null;
    this._self = null;
  }
};
</script>

<style lang="scss">
@import './../scss/mixin.scss';

.logo {
  width: $rem200;
  height: $rem200;
}

.wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.logo1 {
  height: 400px;
}
</style>
